import { GetDamagedCustomerDocumentImagesQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedCustomerDocumentImages/getDamagedCustomerDocumentImagesQuery.type';
import { getDamagedCustomerDocumentImagesFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedCustomerDocumentImages/getDamagedCustomerDocumentImagesQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getDamagedCustomerDocumentImagesQueryOptions = (
  params: GetDamagedCustomerDocumentImagesQueryParamsType,
) => {
  return queryOptions({
    queryKey: ['damagedCustomerDocumentImages', params],
    queryFn: () => getDamagedCustomerDocumentImagesFunction(params),
    enabled: true,
  });
};
